module.exports = __webpack_public_path__ + "static/media/06.e9afa413.png";